import { genericCRUDService, get } from '../../helpers/api';

export const SERVICE_URI = '/validators';
export const BASE_URI = '/api/v1/vw-inspector-transactions';

const { findAll } = genericCRUDService(SERVICE_URI, BASE_URI);

export const findSessionTransactions = async (sessionId) =>
  get(`${SERVICE_URI}${BASE_URI}/findSessionTransactions/${sessionId}`);

export const findControllerSessionTransactions = async (
  sessionId,
  inspectorId,
) =>
  get(
    `${SERVICE_URI}${BASE_URI}/findControllerSessionTransactions/${sessionId}/${inspectorId}`,
  );

export { findAll };
